<main>
  <ng-container *transloco="let t">
    @if (!isPreviewCard()) {
      <div class="justify-content-space-between back-row">
        <div class="justify-content-space-between">
          <div class="back button-container">
            <div class="justify-content-space-between gap-xs">
              <button
                [matTooltip]="t('Back')"
                matTooltipShowDelay="200"
                matTooltipPosition="above"
                (click)="back()"
                class="back-arrow-icon icon icon-m"
                [attr.aria-label]="t('Back')"
              ></button>

              <h2>{{ t('Card') }} {{ store.animal()?.cartonNumber }}</h2>
              <span
                [matTooltip]="
                  t(store.animal()?.exitusLetalis ? 'Exitus Letalis' : 'Alive')
                "
                matTooltipShowDelay="200"
                matTooltipPosition="above"
                [ngClass]="
                  !store.animal()?.exitusLetalis
                    ? 'active-status'
                    : 'no-active-status'
                "
              ></span>
              @if (store.animal()?.lost) {
                <b style="color: red">
                  {{ t('Wanted') }}
                </b>
              }
            </div>
          </div>

          <div class="gap-s">
            <button
              (click)="store.startDashboardTour()"
              class="tour-btn gap-xs"
            >
              <mat-icon class="book-open-blue-icon icon"></mat-icon>
              {{ t('Tour') }}
            </button>

            @if (store.statusOwner() === LoadingStatus.Loaded) {
              <button
                mat-stroked-button
                (click)="store.openPaymentsDialog()"
                class="secondary-btn"
              >
                {{ t("Owner's Financial Card") }}
              </button>
            } @else {
              <anihis-loading-skeleton [height]="'44px'" [minWidth]="'201px'" />
            }

            <!-- @if (store.statusAnimal() === LoadingStatus.Loaded) {
              @if (!store.animal()?.exitusLetalis) {
                <button
                  mat-flat-button
                  [disabled]="
                    store.isFormDialogOpening && store.isFormDialogOpening()
                  "
                  (click)="store.openAddFormDialog(store.animal()!)"
                  class="primary-btn gap-xs"
                >
                  @if (
                    !store.isFormDialogOpening || !store.isFormDialogOpening()
                  ) {
                    <mat-icon class="plus-icon"></mat-icon>
                  }

                  @if (
                    store.isFormDialogOpening && store.isFormDialogOpening()
                  ) {
                    <mat-progress-spinner
                      diameter="20"
                      mode="indeterminate"
                    ></mat-progress-spinner>
                  }

                  {{ t('Add form') }}
                </button>
              }
            } @else {
              <anihis-loading-skeleton [height]="'44px'" [minWidth]="'201px'" />
            } -->

            @if (store.statusAnimal() === LoadingStatus.Loaded) {
              @if (!store.animal()?.exitusLetalis) {
                <button
                  mat-flat-button
                  (click)="store.openAddReportDialog(store.animal()!)"
                  class="primary-btn"
                >
                  <mat-icon class="plus-icon"></mat-icon>
                  {{ t('Add report') }}
                </button>
              }
            } @else {
              <anihis-loading-skeleton [height]="'44px'" [minWidth]="'201px'" />
            }
          </div>
        </div>
      </div>
      <div class="flex gap-4 mb-4">
        @if (store.statusOwner() === LoadingStatus.Loaded) {
          <mat-card
            class="flex-grow h-full"
            id="owner-details"
            style="position: relative"
          >
            <anihis-loading-overlay
              [isLoading]="store.statusOwner() === LoadingStatus.Loading"
              [size]="40"
            />
            <mat-card-content>
              <div class="card-section-header">
                <div>
                  <span class="card-section-label">{{ t('Owner') }}</span>
                  <h3>
                    {{
                      store.owner()?.firstName && store.owner()?.lastName
                        ? store.owner()?.firstName +
                          ' ' +
                          store.owner()?.lastName
                        : '-'
                    }}
                  </h3>
                </div>
                <div class="card-section-actions">
                  <button
                    [matTooltip]="t('Edit owner')"
                    matTooltipShowDelay="200"
                    matTooltipPosition="above"
                    (click)="store.openEditOwnerDialog()"
                    class="edit-icon icon icon-m"
                    [attr.aria-label]="t('Edit owner')"
                  ></button>
                  <button
                    [matTooltip]="t('Preview owner')"
                    matTooltipShowDelay="200"
                    matTooltipPosition="above"
                    (click)="
                      store.infoOwnerDialog(store.owner()!, store.animal()!)
                    "
                    class="preview-icon icon icon-m"
                    [attr.aria-label]="t('Preview owner')"
                  ></button>
                </div>
              </div>
              <div class="card-rows">
                <div class="card-row">
                  <span class="card-row__label">{{ t('Street') }}</span>
                  <span class="card-row__value">{{
                    store.owner()?.contact?.street || '-'
                  }}</span>
                </div>
                <div class="card-row">
                  <span class="card-row__label">{{ t('City') }}</span>
                  <span class="card-row__value">{{
                    store.owner()?.contact?.city || '-'
                  }}</span>
                </div>
                <div class="card-row">
                  <span class="card-row__label">{{
                    t('Owner mobile number')
                  }}</span>
                  <span class="card-row__value">{{
                    store.owner()?.contact?.mobileNumber || '-'
                  }}</span>
                </div>
                <div class="card-row">
                  <span class="card-row__label">{{ t('Email') }}</span>
                  <span class="card-row__value">{{
                    store.owner()?.email || '-'
                  }}</span>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        } @else {
          <div class="flex-grow h-full loading-card-info">
            <anihis-loading-skeleton [height]="'200px'" [minWidth]="'100%'" />
          </div>
        }

        @if (store.statusAnimal() === LoadingStatus.Loaded) {
          <mat-card
            class="flex-grow h-full"
            id="animal-details"
            style="position: relative"
          >
            <anihis-loading-overlay
              [isLoading]="store.statusAnimal() === LoadingStatus.Loading"
              [size]="40"
            />
            <mat-card-content>
              <div class="card-section-header">
                <div>
                  <span class="card-section-label">{{ t('Animal') }}</span>
                  <div class="flex gap-xs items-center">
                    <h3>{{ store.animal()?.name || '-' }}</h3>
                    <mat-icon
                      [ngClass]="
                        store.animal()?.gender === genderType.Male
                          ? 'male-icon'
                          : 'female-icon'
                      "
                    ></mat-icon>
                  </div>
                </div>
                <div class="card-section-actions">
                  <button
                    [matTooltip]="t('Edit animal')"
                    matTooltipShowDelay="200"
                    matTooltipPosition="above"
                    (click)="store.openEditAnimalDialog()"
                    class="edit-icon icon icon-m"
                    [attr.aria-label]="t('Edit animal')"
                  ></button>
                  <button
                    [matTooltip]="t('Preview animal')"
                    matTooltipShowDelay="200"
                    matTooltipPosition="above"
                    (click)="
                      store.infoAnimalDialog(store.animal(), store.owner())
                    "
                    class="preview-icon icon icon-m"
                    [attr.aria-label]="t('Preview animal')"
                  ></button>
                </div>
              </div>
              <div class="card-rows">
                <div class="card-row">
                  <span class="card-row__label">{{ t('Breed') }}</span>
                  <span class="card-row__value">{{
                    t(store.animal()?.breed?.name ?? '') || '-'
                  }}</span>
                </div>
                <div class="card-row">
                  <span class="card-row__label">{{ t('Date Of Birth') }}</span>
                  <span class="card-row__value">{{
                    store.animal()?.birthDateTime
                      ? (store.animal()?.birthDateTime
                        | parseUtcToLocal
                        | localDate)
                      : store.animal()?.birthDateText || '-'
                  }}</span>
                </div>
                <div class="card-row">
                  <span class="card-row__label">{{ t('Microchip') }}</span>
                  <span class="card-row__value">
                    {{ store.animal()?.microchip || '-' }}
                    @if (store.animal()?.microchip) {
                      <span
                        class="help-icon cursor"
                        matTooltipShowDelay="200"
                        [matTooltip]="
                          t('Microchip') +
                          ': ' +
                          (store.animal()?.microchip || '-')
                        "
                        matTooltipPosition="above"
                      ></span>
                    }
                  </span>
                </div>
                <!-- <div class="card-row">
                  <span class="card-row__label">{{ t('Sterilized') }}</span>
                  <span class="card-row__value">
                    @if (store.animal()?.sterilized) {
                      {{ t('Yes') }}
                      <mat-icon class="sterilized-icon cursor"></mat-icon>
                    } @else {
                      -
                    }
                  </span>
                </div> -->
                <div class="card-row">
                  <span class="card-row__label">{{ t('Warning') }}</span>
                  <span class="card-row__value">{{
                    store.animal()?.warning || '-'
                  }}</span>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        } @else {
          <div class="flex-grow h-full loading-card-info">
            <anihis-loading-skeleton [height]="'200px'" [minWidth]="'100%'" />
          </div>
        }
      </div>

      <mat-tab-group
        animationDuration="0ms"
        class="card-histort-tab-group"
        id="menu-management"
        [selectedIndex]="store.selectedTabIndex()"
        (selectedIndexChange)="store.setTabIndex($event)"
      >
        <mat-tab [label]="t('Report')">
          <anihis-report
            [animalUid]="store.animalUid()"
            (reportUid)="store.setReportUid($event)"
            [refreshReports]="store.refreshReports()"
          ></anihis-report>
        </mat-tab>

        <mat-tab [label]="t('Documents')">
          <anihis-documents
            [animalUid]="store.animalUid()"
            [exitusLetalis]="store.animal()?.exitusLetalis"
            [refreshDocuments]="store.refreshDocuments()"
          ></anihis-documents>
        </mat-tab>

        <!-- <mat-tab [label]="t('Forms')">
          <anihis-forms-preview
            [refreshForms]="store.refreshForms()"
            [animalUid]="store.animalUid()"
          ></anihis-forms-preview>
        </mat-tab> -->
      </mat-tab-group>
    }
  </ng-container>
</main>
